{"rating":"4.9","reviewCount":"136","fetchedAt":"2026-09-22T00:00:00.000Z","source":"manual"}